import React, { PropsWithChildren } from "react"
import { Divider, Heading, Stack } from "@chakra-ui/react"

import Icon from "@components/Icon/Icon"

const ArticleQuote = ({ children }: PropsWithChildren) => (
  <Stack spacing={2.5} alignItems="center" my={3} mx={[2.5, 0]}>
    <Icon name="quote" width="33px" height="25px" />
    <Heading as="h4" size="h4" textAlign="center" lineHeight="36px">
      {children}
    </Heading>
    <Divider borderColor="brand.primary" w="80%" />
  </Stack>
)

export default ArticleQuote
